export default value => {
    return value === true;
};
